import { toast } from 'sonner';

import { getEnvVar } from '@/env';

export const debugToast = (description: string) => {
  if (!getEnvVar('ENABLE_DEVTOOLS')) return;
  if (!import.meta.env.DEV) return;
  if (window.systemInfo?.currentWindow?.label !== 'main') return;

  toast.message('Debug Toast', {
    description,
    closeButton: true,
    position: 'bottom-right',
  });
};

export const errorToast = (error: Error, description?: string) => {
  toast.error(error.message, { description, closeButton: true });
};
